export class Question {
    id: string;
    text: string;
    options: { [key: string]: any } = {};
    maxQuestionsLeft = 0;
    type: QuestionType;
    determineNext: () => string;
}

export enum QuestionType {
    DropDown,
    Radio
}
